import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { REVIEW_MODAL } from "@/constants/testIds";

export const ReviewModal = ({ open, onOpenChange }) => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(5);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) {
      toast.error("Please fill in your name and review.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/reviews", { name, message, rating });
      toast.success("Thank you for your review!");
      setName("");
      setMessage("");
      setRating(5);
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={REVIEW_MODAL.dialog} className="max-w-md rounded-[2rem]">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold text-[#0F2520]">Share Your Experience</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((n) => (
              <button
                key={n}
                type="button"
                data-testid={REVIEW_MODAL.starButton(n)}
                onClick={() => setRating(n)}
                className="p-1"
              >
                <Star className={`w-7 h-7 ${n <= rating ? "fill-[#F4D06F] text-[#F4D06F]" : "text-[#DCD7CE]"}`} />
              </button>
            ))}
          </div>
          <Input
            data-testid={REVIEW_MODAL.nameInput}
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="h-12 rounded-xl"
          />
          <Textarea
            data-testid={REVIEW_MODAL.messageInput}
            placeholder="Tell us about your experience..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="rounded-xl min-h-[100px]"
          />
          <Button
            data-testid={REVIEW_MODAL.submitBtn}
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-[#0F2520] hover:bg-[#D97736] text-white font-semibold"
          >
            {loading ? "Submitting..." : "Submit Review"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
